import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { defineMessages, useIntl } from 'react-intl';
const msgs = defineMessages({
    buttonCancel: {
        id: 'dialog.ConfirmationDialog.button.cancel',
        defaultMessage: 'Cancel',
    },
    buttonOk: {
        id: 'dialog.ConfirmationDialog.button.ok',
        defaultMessage: 'Ok',
    },
    buttonSubmit: {
        id: 'dialog.ConfirmationDialog.button.submit',
        defaultMessage: 'Submit',
    },
});
const ConfirmationDialog = ({ title, description, onCancel, onConfirm, children, confirmLabel, confirmDisabled, formName, ...props }) => {
    const intl = useIntl();
    return (React.createElement(Dialog, { fullWidth: true, maxWidth: "sm", ...props },
        React.createElement(DialogTitle, { sx: { pb: 0 } },
            title,
            onCancel || onConfirm ? (React.createElement(IconButton, { "aria-label": "close", onClick: onCancel ? onCancel : onConfirm, sx: {
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                } },
                React.createElement(CloseIcon, null))) : null),
        React.createElement(DialogContent, null,
            React.createElement(DialogContentText, { sx: { py: 1 } }, description),
            children ? React.createElement(Box, null, children) : null),
        React.createElement(DialogActions, null,
            onCancel ? (React.createElement(Button, { onClick: onCancel, variant: "outlined" }, intl.formatMessage(msgs.buttonCancel))) : null,
            onConfirm ? (React.createElement(Button, { onClick: onConfirm, variant: "outlined", disabled: confirmDisabled }, confirmLabel ? confirmLabel : intl.formatMessage(msgs.buttonOk))) : formName ? (React.createElement(Button, { variant: "outlined", type: "submit", form: formName }, intl.formatMessage(msgs.buttonSubmit))) : null)));
};
export default ConfirmationDialog;
